import React, { useEffect, useMemo, useRef, useState } from 'react';
import './Hero.css';
import { Link } from 'react-router-dom';
import { useI18n } from '../../i18n/I18n';

const Hero = () => {
  const slides = useMemo(() => {
    const arr: string[] = [];
    try { arr.push(require('../../images/pct.jpeg')); } catch {}
    try { arr.push(require('../../images/pct2.jpeg')); } catch {}
    return arr;
  }, []);

  const { t, lang } = useI18n();

  const [index, setIndex] = useState(0);
  const [autoPlay, setAutoPlay] = useState(true);
  const touchStartX = useRef<number | null>(null);

  const next = () => setIndex((i) => (i + 1) % (slides.length || 1));
  const prev = () => setIndex((i) => (i - 1 + (slides.length || 1)) % (slides.length || 1));

  // Preload first slide for faster LCP
  useEffect(() => {
    if (!slides.length) return;
    try {
      const l = document.createElement('link');
      l.rel = 'preload';
      l.as = 'image';
      l.href = slides[0];
      document.head.appendChild(l);
    } catch {}
  }, [slides]);

  useEffect(() => {
    if (slides.length <= 1 || !autoPlay) return;
    const reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reduce) return;
    const id = window.setInterval(next, 8000);
    return () => window.clearInterval(id);
  }, [slides.length, autoPlay]);

  // Keyboard navigation with arrow keys
  useEffect(() => {
    const onKey = (e: KeyboardEvent) => {
      if (e.key === 'ArrowLeft') { prev(); setAutoPlay(false); }
      if (e.key === 'ArrowRight') { next(); setAutoPlay(false); }
    };
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [slides.length]);

  const onTouchStart = (e: React.TouchEvent) => {
    touchStartX.current = e.touches[0].clientX;
  };
  const onTouchEnd = (e: React.TouchEvent) => {
    if (touchStartX.current == null) return;
    const dx = e.changedTouches[0].clientX - touchStartX.current;
    if (Math.abs(dx) > 40) {
      if (dx < 0) next(); else prev();
      setAutoPlay(false);
    }
    touchStartX.current = null;
  };

  const onCta = () => {
    try {
      (window as any).dataLayer = (window as any).dataLayer || [];
      (window as any).dataLayer.push({ event: 'cta_click', location: 'hero', label: 'hemen_teklif_alin' });
    } catch {}
  };

  const isSecond = slides.length > 1 && index === 1;
  const titleText = isSecond && lang === 'tr' ? 'Geleceği Sür, Doğayı Koru' : t('hero.title');
  const subtitleText = isSecond && lang === 'tr' ? 'Doğayla uyumlu sürüş keyfi. Elektrikli araçlar sizleri bekliyor!' : t('hero.subtitle');

  return (
    <section className="hero-section">
      <div className="hero-slider" aria-roledescription="carousel" aria-label="Manşet görselleri">
        <div className="hero-slides" style={{ transform: `translateX(-${index * 100}%)` }} onTouchStart={onTouchStart} onTouchEnd={onTouchEnd}>
          {(slides.length ? slides : ['']).map((src, i) => (
            <div key={i} className={`hero-slide ${i === index ? 'is-active' : ''} ${i === 0 ? 'is-first' : ''}`} style={{ backgroundImage: src ? `url(${src})` : 'none' }} role="group" aria-label={`${i + 1} / ${slides.length || 1}`}></div>
          ))}
        </div>
        {slides.length > 1 && (
          <>
            <button className="hero-arrow left" aria-label="Önceki" onClick={() => { prev(); setAutoPlay(false); }}>‹</button>
            <button className="hero-arrow right" aria-label="Sonraki" onClick={() => { next(); setAutoPlay(false); }}>›</button>
            <button className="hero-pp" aria-label={autoPlay ? 'Duraklat' : 'Oynat'} onClick={() => setAutoPlay((v) => !v)}>{autoPlay ? '⏸' : '▶'}</button>
          </>
        )}
      </div>
      <div className="hero-overlay"></div>
      <div className="hero-content">
        <h1>{titleText}</h1>
        <p>{subtitleText}</p>
        <div className="hero-actions">
          <Link to="/teklif" className="hero-button hero-button--primary" onClick={onCta}>{t('hero.cta')}<span className="chev">›</span></Link>
        </div>
        <span style={{ position: 'absolute', width: 1, height: 1, padding: 0, margin: -1, overflow: 'hidden', clip: 'rect(0,0,0,0)', whiteSpace: 'nowrap', border: 0 }} aria-live="polite">Slayt {index + 1} / {slides.length}</span>
      </div>
    </section>
  );
};

export default Hero; 